// extracted by mini-css-extract-plugin
export default {"breadcrumb":"BreadCrumbs_breadcrumb__4P+PZ"};